import { attachDynamicManifest } from './manifestService'
import { initInstallPromptListener } from './installPromptListener'
import { registerServiceWorker } from './swRegister'

export async function initPwa() {
  try {
    initInstallPromptListener()
  } catch {}
  try {
    await attachDynamicManifest()
  } catch {}
  try {
    await registerServiceWorker()
  } catch {}
}
